var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "27",
      "height": "32",
      "viewBox": "0 0 27 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M22.958 1H4.874a2.583 2.583 0 00-2.583 2.583v24.542a2.583 2.583 0 002.583 2.583h18.084a2.583 2.583 0 002.583-2.583V3.583A2.583 2.583 0 0022.958 1zM1 6.167h2.583M1 10.042h2.583M1 13.917h2.583M1 17.792h2.583M1 21.667h2.583M1 25.542h2.583",
      "stroke": "#F1D5AA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.137 12.562l2.97 2.971a2.518 2.518 0 103.562-3.562L9.698 9M7.917 10.782L20.405 23.27M17.015 15.532L9.207 23.34M18.202 10.783a2.518 2.518 0 113.561 3.56l-1.187 1.189a2.52 2.52 0 01-3.56-3.563l1.186-1.186z",
      "stroke": "#F1D5AA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }